import React, { useState } from 'react'
import styled from 'styled-components'
import { Row, Col, Button, Form } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import PhoneInput from 'react-phone-input-2'
import TaglineM from '../../images/registration/taglineM.png'
import TaglineD from '../../images/registration/taglineD.png'
import banner from '../../images/registration/SignUp_Desktop.png'

import { COLORS, SIZES } from '../../styles/theme'
import Axios from 'axios'
import config from '../../config'
import { toast } from 'react-toastify'
import routes from '../../routes'

const Page = styled.div`
  min-height: 100vh;
  background-image: url(${config.assets.postRegister.landscape});
  background-repeat: no-repeat;
  background-size: cover;
  background-position:left;
  padding: 0 1.5em;
  padding-bottom: 4.5em;
  padding-top: 2em;
  color: #002060;
  img#banner {
    display: none;
  }
  ${SIZES.mobile} {
    background-image: url(${config.assets.postRegister.portrait});
    padding: 0;
    padding-bottom: 2.5em;
    padding-top: 1em;
    font-size: 0.9em;
    img#banner {
      display: block;
      width: 90%;
    }
  }
  
  .row {
    ${SIZES.mobile}{
      .mobile-hide {
        display: none;
      }
    }
    h6 {
      margin: 16px;
      font-weight: 600;
      ${SIZES.mobile} {
        margin: 8px;
      }
    }
    h6.subtitle {
      font-weight: 500;
      margin: 24px 0;
    }
    #event {
      padding: 2rem 0;
      padding-left: 60px;
      padding-right: 36px;
      align-self: center;
      h4 {
        font-weight: 600;
      }
      h4#info {
        color:#279AAC;
      }
      p {
        margin: 0;
        strong {
          color: #009A47;
        }
      }
      ${SIZES.mobile} {
        text-align: center;
        align-self: flex-start;
        padding: 0;
        margin: 8px auto;
        margin-bottom: 32px;
        h4 {
          margin: 0;
        }
        h4#info {
          color: #FFFFFF;
        }
        p strong {
          color: #AEF3FD;
        }
      }
    }
    .register-form {
      padding: 2.5em 0;

      .form-group {
        width: 100%;
        margin: 8px auto;
        background: #F8F4FF;
        border: 1px solid #0269EA;
        border-radius: 25px;
        font-weight: 600;
        text-align: center;
        padding-right: 16px;
        label {
          color: #00469D;
          padding: 0 8px;
          margin: 0 auto;
          padding-right: 0;
          font-size: 13px;
        }
        .required:before {
          content:"* ";
          color: red;
        }
        input[type='tel'],
        .form-input {
          display: block;
          color: #279AAC;
          letter-spacing: 1px;
          width: 100%;
          font-weight: 500;
          background: transparent;
          border: none;
          padding: 4px 24px;
          outline: none;
        }
        .react-tel-input {
          color: #279AAC;
          input[type='tel'] {
            padding-left: 56px;
            height: 35px;
            box-shadow: none;
          }
          .country-list {
            margin: 0;
          }
          .flag-dropdown {
            background: transparent;
            border: none;
            padding-left: 16px;
            .selected-flag {
              background: transparent;
            }
          }
        }
      }
      #password {
        width: 12px;
        margin: 2px 4px;
      }
    }
  }
  .form-check {
    display:flex;
    align-items: flex-start;
    .form-check-label {
      color: #002F62;
      font-weight: 500;
      font-size: 12px;
      margin-left: 8px;
      a {
        color: #B5F1FF;
        text-decoration: underline;
      }
    }
  }
  
  button.submit-btn {
    background: #002060;
    width: 48%;
    color: #AEF3FD;
    font-weight: 500;
    font-style: italic;
    border: 1px solid ${COLORS.primary};
    border-radius: 56px;
    display: flex;
    justify-content: space-between;
    padding: 4px 24px;
    margin: 16px 0;
    margin-bottom: 0;
    font-size: 1em;
    outline: none;
    box-shadow: none;

    ${SIZES.mobile} {
      padding: 4px 24px;
      width: 100%;
    }

    &:disabled {
      cursor: not-allowed;
      background: grey;
      border: solid 1px ${COLORS.primary};
    }

    div {
      line-height: 32px;
    }
    div.arrow {
      line-height: 24px;
      font-size: 1.5em;
      align-self: flex-end;
    }
  }
`

export default function RegisterFormPage() {
  const history = useHistory()

  const [loading, setLoading] = useState(false)
  const [salutation, setSalutation] = useState('Mr')
  const [placePractice, setPlacePractice] = useState('')
  const [email, setEmail] = useState('')
  const [MMC, setMMC] = useState('')
  const [repName, setRepName] = useState('')
  const [password, setPassword] = useState('')
  const [fullName, setFullName] = useState('')
  const [phone, setPhone] = useState('60')
  const [NRIC, setNRIC] = useState('')
  const [state, setState] = useState("Kuala Lumpur")
  const [repContact, setRepContact] = useState('')
  const [agree, setAgree] = useState(false)
  const optionList = [
    'Mr',
    'Ms',
    'Mrs',
    'Dr',
    'Dato',
    'Datuk',
    'Prof.',
    'Prof. Dr',
    'Prof. Dato Dr',
    'Assoc. Prof',
  ]
  const stateList = [
    'Johor',
    'Kedah',
    'Kelantan',
    'Kuala Lumpur',
    'Melaka',
    'Negeri Sembilan',
    'Pahang',
    'Penang',
    'Perak',
    'Perlis',
    'Sabah',
    'Sarawak',
    'Selangor',
    'Terengganu',
    'Others',
  ]

  const handleCheckBox = (e) => {
    setAgree(e.target.checked)
  }
  const handleEmailInput = (e) => {
    setEmail(e.target.value.toLowerCase())
  }
  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    const options = {
      salutation,
      full_name: fullName.trim(),
      email,
      phone,
      password: password.trim(),
      place_of_practice: placePractice,
      mmc_number: MMC,
      nric_number: NRIC,
      state: state,
      representative_name: repName.trim(),
      representative_contact: repContact.trim(),
    }
    Axios.post(`${config.apiUrl}/api/v1/register`, options)
      .then(() => {
        setLoading(false)
        history.push(routes.postRegister)
      })
      .catch((err) => {
        setLoading(false)
        toast(err.response.data.message)
      })
  }

  const hasEmptyField = !(
    salutation.length &&
    placePractice.length &&
    email.length &&
    fullName.length &&
    phone.length >= 7 &&
    NRIC.length &&
    state.length &&
    agree &&
    password.length >= 8 
  )

  return (
    <Page>
      <img id="banner" src={TaglineM} alt="event-tagline" className="mx-auto mt-5" />
      <Row id="main" noGutters className="px-4 pl-md-0 pt-2 pb-3">

        <Col md={4} className="mobile-hide">
          <img width="100px" src={config.assets.logo.landscape} alt="logo" className="mx-auto" />
          <img width="100%" src={banner} alt="event-banner" className="mx-auto" />
        </Col>

        <Col lg={8} className="px-md-4">
          <img width="100%" src={TaglineD} alt="event-tagline" className="mx-auto mobile-hide" />
          <h6 className="subtitle">Kindly fill in your details below to complete registration</h6>
          {hasEmptyField && (
            <p className="text-danger m-0">
              * Please fill in the required field to proceed.
            </p>
          )}
          <Row className="register-form py-3" noGutters>
            <Col md={6} className="pr-md-4">
              <Form.Group>
                <label className="required">Salutation</label>
                <select
                  className="form-input"
                  value={salutation}
                  onChange={(e) => setSalutation(e.target.value)}
                >
                  {optionList.map((item, i) => (
                    <option key={`option-${i}`} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Form.Group>
            </Col>
            <Col md={6} className="pr-md-4">
              <Form.Group>
                <label className="required">Full Name (as per NRIC or Passport)</label>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6} className="pr-md-4">
              <Form.Group>
                <label className="required">Place of Practice (Hospital/Clinic/Pharmacy)</label>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={placePractice}
                  onChange={(e) => setPlacePractice(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6} className="pr-md-4">
              <Form.Group>
                <label className="required">Mobile Number</label>
                <PhoneInput
                  inputProps={{ required: true }}
                  className="form-input"
                  value={phone}
                  onChange={(phone) => setPhone(phone)}
                />
              </Form.Group>
            </Col>
            <Col md={6} className="pr-md-4">
              <Form.Group>
                <label className="required">Email Address</label>
                <input
                  className="form-input"
                  required
                  type="email"
                  value={email}
                  onChange={handleEmailInput}
                />
              </Form.Group>
            </Col>
            <Col md={6} className="pr-md-4">
              <Form.Group>
                <label className="required">NRIC No</label>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={NRIC}
                  onChange={(e) => setNRIC(e.target.value)}
                />
              </Form.Group>
            </Col>
            {/* <Col md={6} className="pr-md-4">
              <Form.Group>
                <label className="required">MMC No</label>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={MMC}
                  onChange={(e) => setMMC(e.target.value)}
                />
              </Form.Group>
            </Col> */}
            <Col md={6} className="pr-md-4">
              <Form.Group>
                <label className="required">State</label>
                <select
                  className="form-input"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                >
                  {stateList.map((item, i) => (
                    <option key={`state-${i}`} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Form.Group>
            </Col>
            {/* <Col md={6} className="pr-md-4">
              <Form.Group>
                <label>NN Sales Representative Name</label>
                <input
                  className="form-input"
                  type="text"
                  value={repName}
                  onChange={(e) => setRepName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6} className="pr-md-4">
              <Form.Group>
                <label>NN Sales Representative Contact</label>
                <input
                  className="form-input"
                  type="text"
                  value={repContact}
                  onChange={(e) => setRepContact(e.target.value)}
                />
              </Form.Group>
            </Col> */}
            <Col md={6} className="pr-md-4">
              <Form.Group>
                <label className="required">
                  Password (min 8 characters)
                  <svg id="password" viewBox="0 0 48 48">
                    <circle fill="#0269EA" cx="24" cy="24" r="21"/>
                    <rect x="22" y="22" fill="#fff" width="4" height="11"/>
                    <circle fill="#fff" cx="24" cy="16.5" r="2.5"/>
                  </svg>
                </label>
                <input
                  className="form-input"
                  required
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
            </Col>
            
            <div className="form-check">
              <input 
                type="checkbox" 
                id="agree-box" 
                onChange={handleCheckBox}
              />
              <label className="form-check-label">
                <span className="text-danger">*</span>&nbsp;I have read and agree to&nbsp;
                <a href="https://tinyurl.com/y26hlb29" target="_blank" rel="noopener noreferrer">
                  Privacy Data Statement
                </a>
                  &nbsp;&&nbsp;
                <a href="https://tinyurl.com/y3dkrfz4" target="_blank" rel="noopener noreferrer" >
                  Consent
                </a>
              </label>
            </div>
            <div className="w-100">
              <Button
                type="submit"
                className="submit-btn"
                variant="default"
                disabled={hasEmptyField || loading}
                onClick={handleSubmit}
              >
                <div>{loading ? 'Loading...' : 'SUBMIT'}</div>
                <div className="arrow">⇀</div>
              </Button>
            </div>
          </Row>
        </Col>
      </Row>
    </Page>
  )
}
